import { render } from "./BairroItem.vue?vue&type=template&id=28e85d72&scoped=true"
import script from "./BairroItem.vue?vue&type=script&lang=js"
export * from "./BairroItem.vue?vue&type=script&lang=js"

import "./BairroItem.vue?vue&type=style&index=0&id=28e85d72&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e85d72"]])

export default __exports__